export default "__VITE_ASSET__CpyIG9E4__"